export const BRAND = {
  name: "Optilase",
  legalName: "Optilase",
  domain: "optilase.com",
  wordmark: "OPTILASE",
  logoAlt: "Optilase Logo",
} as const;

export const BRAND_ORIGIN = `https://${BRAND.domain}`;

const BRAND_SUFFIX = ` | ${BRAND.name}`;

/** Appends the brand suffix unless it is already the end of the title. */
export function withBrand(title?: string): string {
  const trimmed = (title ?? "").trim();
  if (!trimmed) return BRAND.name;
  return trimmed.toLowerCase().endsWith(BRAND_SUFFIX.toLowerCase())
    ? trimmed
    : `${trimmed}${BRAND_SUFFIX}`;
}
